import React from "react";
import { Box } from "@mui/material";
import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import MetabaseEmbed from "./MetabaseEmbed";
import AnalysisArticles from "./AnalysisArticles";

const AnalysisPage = () => {
  return (
    <DashboardLayout>
      <MDBox>
        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={1}>
          Analysis
        </MDTypography>
        <MDTypography variant="body2" color="text" mb={3}>
          Dashboard trends plus sales, return, profit, and Otto advertising KPIs
          by article.
        </MDTypography>
        <Box>
          <MetabaseEmbed />
          <AnalysisArticles />
        </Box>
      </MDBox>
    </DashboardLayout>
  );
};

export default AnalysisPage;
